export var PACKAGE_SOURCE = "components";
export var PACKAGE_VERSION = "3.0.0 (a046f4d8)";
export var GIT_SHA = "a046f4d8";
export var THEME = "default";
export var SYSTEM = "core";
export var ALWAYS_VISUAL_REFRESH = false;
export var INCLUDE_ONE_THEME = true;